var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18L6 6M6 18L18 6",
    stroke: "#000",
    fill: "none"
  })));
}

export default "data:image/svg+xml,%3csvg width='24px' height='24px' preserveAspectRatio='xMidYMid meet' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cpath d='M18 18L6 6' opacity='1' fill-opacity='0' stroke='%23000000' stroke-width='1' stroke-opacity='1' /%3e %3cpath d='M6 18L18 6' opacity='1' fill-opacity='0' stroke='%23000000' stroke-width='1' stroke-opacity='1' /%3e %3c/svg%3e";
export { SvgClose as ReactComponent };